import type { Request } from '../../../index';
import type { VendingMachineKind } from 'app/dataTypes/vending/MachineKind.types';

export type Params = {
  title: string,
  number: string,
  model_id: number,
  version_id: number,
  kind: VendingMachineKind,
  school_id: number,
  building_id: number,
  sale_point_id: number,
}

export type Machine = {
  id: number,
  title: string,
  // number: string,
  model_id: number,
  version_id: number,
  kind: VendingMachineKind,
  school_id: number,
  building_id: number,
  sale_point_id: number,
  photo_url: string,
  deleted: null | boolean,
}

export type Result = {
  data: Machine,
  result?: 'success',
}

export const POST_VENDING_MACHINES: Request<Params, Result, void> = [
  'data/vending/machines',
  'post',
  ['data'],
];
